// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterPhone: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14">
            <path
                fill="currentColor"
                d="M0 .875 3.938 0l2.187 3.938L3.834 5.77a10.553 10.553 0 0 0 4.396 4.396l1.832-2.291L14 10.063 13.125 14h-.875C5.485 14 0 8.515 0 1.75V.875z"
            />
        </svg>
    );
};

export default React.memo(FooterPhone);
